import { render, staticRenderFns } from "./ViberDetailInfo.vue?vue&type=template&id=512b3aab&"
import script from "./ViberDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./ViberDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports